import React from "react";

// The header titles for the columns of the basket information displayed
export default function BasketTableHeader() {
  return (
    <div className="Food-Table">
      <div className="Basket-Table-Header">
        <h2 className="Header-2">Item</h2>
      </div>
      <div className="Basket-Table-Header">
        <h2 className="Header-2">Description</h2>
      </div>
      <div className="Basket-Table-Header">
        <h2 className="Header-2">Farm Name</h2>
      </div>
      <div className="Basket-Table-Header">
        <h2 className="Header-2">Price</h2>
      </div>
      <div className="Basket-Table-Header">
        <h2 className="Header-2">Quantity</h2>
      </div>
      <div className="Basket-Table-Header">
        <h2 className="Header-2">Remove</h2>
      </div>
    </div>
  );
}
